<template>
		<div class="page-container">
			<center><p class="sig">Silence is golden!</p></center>
		</div>
</template>

<script>
import router from '@/router'
const token = localStorage.getItem('token')
export default {
  name: 'LoginFake',
  mounted(){
  	if (token) {
  		router.push('/goadmin/dashboard')
  	}
  }
}
</script>

<style lang="css" scoped>

.page-container{
	overflow: hidden!important;
	background: white!important;
}

.sig{
	font-size: 15px;
}

p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginFake.vue